import type { IPlainTooltipProps } from "@similarweb/ui-components";
import { IconButton, PlainTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

export type AssignToOtherUsersButtonProps = {
    isDisabled: boolean;
    isTooltipDisabled?: boolean;
    isLoading: boolean;
    tooltipContent?: IPlainTooltipProps["tooltipContent"];
    onClick(): void;
};

const AssignToOtherUsersButton = (props: AssignToOtherUsersButtonProps) => {
    const {
        isDisabled,
        isLoading,
        tooltipContent,
        isTooltipDisabled = typeof tooltipContent === "undefined" || isDisabled,
        onClick,
    } = props;

    return (
        <PlainTooltip
            enabled={!isTooltipDisabled}
            maxWidth={250}
            placement="top"
            tooltipContent={tooltipContent}
        >
            <div>
                <IconButton
                    iconName="assign-to-user"
                    isDisabled={isDisabled || isLoading}
                    isLoading={isLoading}
                    type="flat"
                    onClick={onClick}
                    dataAutomation="si-multi-selector-assign-to-other-users-button"
                >
                    {translate("si.multi_selector.assign.btn.title")}
                </IconButton>
            </div>
        </PlainTooltip>
    );
};

export default AssignToOtherUsersButton;
